import { k } from "../kaplay";

import { spikes } from "../components/spikes";
import { fireballs } from "../components/fireballs";

import { properties } from "./properties";

const sword_cards = [
  {
    id: "sword_double",
    unique: true,
    title: "Doubling",
    description: "Gain another sword",
    choose: () => {
      const player = k.get("player")[0];
      player.setSwordNumber(properties.sword.number + 1);
    }
  },
  {
    id: "sword_triple",
    unique: true,
    require: ["sword_double"],
    title: "Tripling!",
    description: "Gain another sword",
    choose: () => {
      const player = k.get("player")[0];
      player.setSwordNumber(properties.sword.number + 1);
    }
  },
  {
    id: "sword_quadruple",
    unique: true,
    require: ["sword_triple"],
    title: "Fork!!!!",
    description: "Gain another sword",
    choose: () => {
      const player = k.get("player")[0];
      // console.log(player);
      player.setSwordNumber(properties.sword.number + 1);
    }
  },
  {
    id: "sword_damage",
    title: "Sharper!",
    description: "Increase sword damage",
    choose: () => {
      k.get("sword").forEach((sword) => {
        sword.damage = sword.damage + 1;
      });
      properties.sword.damage = properties.sword.damage + 1;
    }
  },
  {
    id: "sword_big",
    unique: true, 
    title: "Big Sword",
    description: "Increase sword size",
    choose: () => {
      k.get("sword").forEach((sword) => {
        sword.scaleTo(2.3);
      });
      properties.sword.scale = 2.3;
    }
  },
  {
    id: "sword_rotSpeed_1",
    unique: true, 
    title: "Woosh",
    description: "Increase sword rotation speed",
    choose: () => {
      properties.sword.rotSpeed = 3;
    }
  },
  {
    id: "sword_rotSpeed_2",
    unique: true, 
    require: ["sword_rotSpeed_1"],
    title: "Woooosh",
    description: "Increase sword rotation speed",
    choose: () => {
      properties.sword.rotSpeed = 4;
    }
  },
]

sword_cards.forEach((sword) => {
  sword.icon = {
    name: "sword",
    scale: 2,
    angle: 45
  }
})


const spikes_cards = [
  {
    id: "spike_use",
    unique: true,
    title: "Spiky",
    description: "Create spikes",
    choose: () => {
      const player = k.get("player")[0];
      player.use(spikes());
    }
  },
  {
    id: "spike_add",
    unique: false,
    require: ["spike_use"],
    title: "More !",
    description: "Create one more spike",
    choose: () => {
      const player = k.get("player")[0];
      player.setSpikeNumber(properties.spike.number + 1);
    }
  },
  {
    id: "spike_fast_1",
    unique: true,
    require: ["spike_use"],
    title: "Fast",
    description: "Spikes spawn faster",
    choose: () => {
      properties.spike.spawnSpeed = 3;
    }
  },
  {
    id: "spike_fast_2",
    unique: true,
    require: ["spike_use", "spike_fast_1"],
    title: "Faster",
    description: "Spikes spawn faster",
    choose: () => {
      properties.spike.spawnSpeed = 1;
    }
  },
  {
    id: "spike_damage",
    title: "Pointy",
    require: ["spike_use"],
    description: "Increase spike damage",
    choose: () => {
      properties.sword.damage = properties.sword.damage + 1;
    }
  },
  {
    id: "spike_big",
    unique: true, 
    title: "Fat",
    require: ["spike_use"],
    description: "Increase spike size",
    choose: () => {
      properties.spike.scale = 1.7;
    }
  },
]

spikes_cards.forEach((sword) => {
  sword.icon = {
    name: "spike",
    scale: 2,
    angle: 0
  }
})


const fireballs_cards = [
  {
    id: "fireball_use",
    unique: true,
    title: "Magic !",
    description: "Create a fireball",
    choose: () => {
      const player = k.get("player")[0];
      player.use(fireballs());
    }
  },
  {
    id: "fireball_add",
    unique: false,
    require: ["fireball_use"],
    title: "More !",
    description: "Create one more fireball",
    choose: () => {
      const player = k.get("player")[0];
      player.setFireballNumber(properties.fireball.number + 1);
    }
  },
  {
    id: "fireball_fast_1",
    unique: true,
    require: ["fireball_use"],
    title: "Fast",
    description: "Fireballs spawn faster",
    choose: () => {
      properties.fireball.spawnSpeed -= 1;
    }
  },
  {
    id: "fireball_fast_2",
    unique: true,
    require: ["fireball_use", "fireball_fast_1"],
    title: "Faster",
    description: "Fireballs spawn faster",
    choose: () => {
      properties.fireball.spawnSpeed -= 1;
    }
  },
  {
    id: "fireball_fast_3",
    unique: true,
    require: ["fireball_use", "fireball_fast_2"],
    title: "Fastest",
    description: "Fireballs spawn faster",
    choose: () => {
      properties.fireball.spawnSpeed -= 1;
    }
  },
  {
    id: "fireball_damage",
    title: "Firy",
    require: ["fireball_use"],
    description: "Increase fireball damage",
    choose: () => {
      properties.sword.damage = properties.sword.damage + 1;
    }
  },
  {
    id: "fireball_big",
    unique: true, 
    title: "Fat",
    require: ["fireball_use"],
    description: "Increase fireball size",
    choose: () => {
      properties.fireball.scale = 1.7;
    }
  },
]

fireballs_cards.forEach((sword) => {
  sword.icon = {
    name: "fire",
    scale: 2,
    angle: 0
  }
})

export const activeCardIds = [];
export const cards = [...sword_cards, ...spikes_cards, ...fireballs_cards];